
import { DATA_VERFICATION_TABLE, DOWNLOAD_DATA_VERIFICATION_PROJECT, GET_PROJECT_DATA } from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchDataVerificationStart,
  fetchDataVerificationSuccess,
  fetchDataVerificationFailure,
  fetchDataVerificationProjectStart,
  fetchDataVerificationProjectSuccess,
  fetchDataVerificationProjectFailure,
  fetchVerificationDownloadStart,
  fetchVerificationDownloadSuccess,
  fetchVerificationDownloadFailure,
} from "../../reducer/DataVerification/DataVerificationTable";


let isGetDataVerification = false;
let isfetchDataProjectList = false;
let isDownloadVerificationCSV = false;
// ............. Get Profile Details.................

export const GetDataVerification =
  (projectId, currentPage, searchTerm, itemsPerPage) => async (dispatch) => {
    if (isGetDataVerification) return;
    isGetDataVerification = true;
    dispatch(fetchDataVerificationStart());
    try {
        const params = {
        page: currentPage,
        size: itemsPerPage,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }
      const response = await axiosInstance.get(`${DATA_VERFICATION_TABLE}`, {
          params,
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
       dispatch(
         fetchDataVerificationSuccess(response?.data)
       );
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(fetchDataVerificationFailure(error.message));
    } finally {
      isGetDataVerification = false;
    }
  };


// ............................ Get data of Managae Project Prooject List .......................

export const fetchDataProjectList =
  ( searchTerm) =>
  async (dispatch) => {
    if (isfetchDataProjectList) return;
    isfetchDataProjectList = true;
    dispatch(fetchDataVerificationProjectStart());
    try {
      const params = {
        page: 1,
        size: 1000,
        sort: "createdAt",
        order: "DESC",
      };
      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${GET_PROJECT_DATA}`, {
        params,
      });
      dispatch(
        fetchDataVerificationProjectSuccess({
          data: response?.data?.result,
        })
      );
    } catch (error) {
      dispatch(
        fetchDataVerificationProjectFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isfetchDataProjectList = false;
    }
  };


// ............................... Download Data Verification CSV ................................. 

  export const DownloadDataVeridficationCSV = (projectId) => async (dispatch) => {
    if (isDownloadVerificationCSV) return;
    isDownloadVerificationCSV = true;
    dispatch(fetchVerificationDownloadStart());
    try {
       const response = await axiosInstance.get(
         `${DOWNLOAD_DATA_VERIFICATION_PROJECT}`,
         { params: { project_id: projectId },}
       );
     if (response.status !== 200) {
       throw new Error("Failed to fetch inspector details.");
     }
     dispatch(fetchVerificationDownloadSuccess(response?.data));
    } catch (error) {
      dispatch(
        fetchVerificationDownloadFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isDownloadVerificationCSV = false;
    }
  };